module.exports = __webpack_public_path__ + "img/product13.9a8f1aa4.png";